<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1 style="text-align: right;">Acknowledgements</h1>
<p style="text-indent:0px;">I would like to express my deepest gratitude to Professor Abdelkrim Berrah for his unwavering support, collegiality and mentorship throughout this journey.</p>
<p style="text-indent:0px;">I want to thank my wife, Saliha, and my wonderful children, Asmaa, Imane, Soumaia, Ahmed, Isra and Dania, who mean</p>
<p style="text-indent:0px;">everything to me. Thank you for your patience, enthusiasm and support.</p>
<p style="text-indent:0px;">I would like to thank my parents, who were very proud of me. No kid could have been loved or supported more.</p>
<p style="text-indent:0px;">I want to thank also my brothers: Nacer, Abdelkader, Ahmed and Fouad, as well as my cousins Saad Haouimi, Larbi Dekoumi and my friend Professor Samir Rouabhia Head and Chairman Department of Internal Medicine CHU Benflis, Batna, Algeria.</p>
<p style="text-indent:0px;">A big thanks to all staff of the Medical Imaging Center “Aures”, Samia Hocine, Assia Kendri, Karima Chennaf, Rahima Bougouffa, Khoukha Bouzidi, Houssem-eddine Kouachi, Mustapha Benguiba, Mustapha Aoura, Atef Bouguelaa, Nadia Bouzenag, Amar Gasmi, Mohamed Gasmi, Bouguelaa M’hammed and Allouache Salah.</p>
<p style="text-indent:0px;">Finally, I would like to express my gratitude to Mr David Learner, executive editor and Mr Vinh Tran, production coordinator at Austin Macauley Publishers Ltd, London (United Kingdom).</p>
<p style="text-align: right;">Ammar Haouimi </p><br/><p style="text-indent:0px;">I would like to pay special thanks and appreciation to the many people who offered help and support at various stages in</p>
<p style="text-indent:0px;">my life.</p>
<p style="text-indent:0px;">A special thanks to my colleague Doctor Ammar Haouimi for his patience, help and collaboration, without him this book may not have been completed.</p>
<p style="text-indent:0px;">Finally, I want to thank my family members for their vital support and love. Without them I could never have achieve my goals.</p>
<br/>
<p style="text-align: right;">Rabah Bouguelaa</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?457ec006